<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
    @hidden="onHide"
  >
    <b-card>

      <div class="mb-1">
        <b>Paciente:</b> {{ paciente }}
      </div>

      <b-alert 
        variant="success" 
        show class="p-2"
      >
        <div class="row align-items-center">
          <h5 for="" class="mx-1">Estado de la atencion:</h5>

          <v-select
            id="estadorevmult" 
            v-model="estadoRevision" 
            :options="estadoAtencionOpts"
            placeholder="Estado de la atención." 
            :reduce="option => option.value" 
            label="text"
            class="col-5"
            :disabled="onlyView"
          />

          <b-button
            v-if="!onlyView"
            class="ml-3"
            variant="success"
            @click="onChangeState"
          >
            Cambiar estado
          </b-button>

          <b-button
            v-if="onlyView && estadoRevision === '1'"
            class="ml-2"
            variant="success"
            @click="onChangeToRevisado"
          >
            Cambiar a Revisado
          </b-button>

        </div>

      </b-alert>
      
      <br>
      <hr>

      <div class="d-flex align-items-center justify-content-between mb-2">
        <h5>Comentarios de validación</h5>
        <b-button
          v-if="!onlyView"
          class="" 
          variant="warning"
          @click="onEditComment(null)"
        >+ Comentario</b-button>
      </div>

      
      <div 
        class="row d-flex align-items-center position-relative comentario"
        v-for="comentario in allComentarios"
        :key="comentario.token"
        style=""
      >

        <div 
          class="col-12 d-flex justify-content-end"
        >   

          <div 
            class="col-2 d-flex align-items-center"
            :class="comentario.estadoComentario === '1' ? 'text-warning' : 'text-success'"
          >
            <span>
              {{ estadoComentarioText(comentario.estadoComentario) }}
            </span>
          </div> 

          <b-button 
            v-if="comentario.estadoComentario === '2' && !onlyView"
            variant="warning" 
            size="sm"
            title="Marcar como visto"
            @click="onCambioEstado(comentario, '1')"
          >
            <i class="fa-solid fa-bell"/>
          </b-button>

          <b-button 
            v-if="comentario.estadoComentario === '1' && onlyView"
            variant="warning" 
            size="sm"
            title="Marcar como visto"
            @click="onCambioEstado(comentario, '2')"
          >
            <i class="fa-regular fa-eye"/>
          </b-button>

          <b-button
            v-if="canEditComentario(comentario.usuarioCreador.username)"
            title="Editar comentario"
            size="sm"
            variant="info"
            @click="onEditComment(comentario)"
          >
            <i class="fas fa-edit"/>
          </b-button>


        </div>

        <div class="col-11">

          <div class="col-12">
            <b>Autor:</b>
            {{ comentario.usuarioCreador.username + " - " + comentario.usuarioCreador.firstName + " " + comentario.usuarioCreador.lastName }}
          </div>
  
          <div class="col-12">
            <b>Fecha ultimo cambio:</b>
            {{ formatDateToDB(comentario.ultimoCambio) }}
          </div>
  
          <div class="col-12">
            <b>Comentario:</b>
            {{ comentario.comentario }}
          </div>
        </div>

        <div>
          

          <span 
            class="text-success"
            v-if="comentario.estadoComentario === '3' && onlyView"
          >Visto</span>

        </div>

      </div>

      <EmptyResults
        v-if="allComentarios && !allComentarios.length"
        message="No existen comentarios"
      />
      
      <b-modal
        v-if="comentarioToEdit"
        class="mt-3" 
        v-model="showEditComentario"
        hide-footer
      >
        <h5  class="text-center mb-2">
          {{  comentarioToEdit.token ? 'Editar comentario' : 'Nuevo comentario' }}
        </h5>
        
        <b-form-textarea
          v-model="comentarioToEdit.comentario"
          placeholder="Comentario de validacion"
          rows="3"
          max-rows="6"
        />

        <div class="text-right my-2">
          <b-button 
            variant="primary" 
            @click="onSaveComentario(comentarioToEdit)"
          >
            Guardar
          </b-button>
        </div>
      </b-modal> 

    </b-card>
    
  </b-modal>
</template>

<script>
import { EmptyResults } from '@/shared/components';
import vSelect from "vue-select";
import { formatDateToDB, comprobarRoles } from '@/shared/helpers';
import { ROLES } from '@/shared/constants';
import { atencionAuditoriaService, atencionMedicaService } from '../../services';

export default {
  name: "AtencionValidacionComentario",

  components: {
    EmptyResults,
    vSelect
  },

  data() {
    return {

      paciente: null,

      estadoRevision: null,

      isVisible: false,
      tokenAtencion:null,
      comentarios:null,
      onlyView: false,

      comentarioOfUser: null,
      comentariosOthersUsers: null,
      allComentarios:null,

      comentarioValidacion: null,
      showEditComentario: false,
      comentarioToEdit: null,

      estadoComentarioOpts:[
        { value:'1', text:'Notificado' },
        { value:'2', text:'Visto' },
        { value:'3', text:'Concluida' },
      ],


      estadoAtencionOpts: [
        { value: '0', text: 'Atendida' },
        { value: '1', text: 'Por revisar' },
        { value: '2', text: 'Revisada' },
        { value: '3', text: 'Concluida' }, 
        { value: '4', text: 'Anulada' },  
        { value: '5', text: 'Auditada' } 
      ],

      estadoValidacion:'1',

      formatDateToDB: formatDateToDB
    }
  },

  created() {
    this.setToken();
  },

  methods: {

    async onChangeState(){
      const responseUpdateState = await atencionMedicaService.updateByToken(this.tokenAtencion, { estadoRevision: this.estadoRevision });

      if (!responseUpdateState){
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'No se ha podido actualizar el estado de la atención',
        });

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Éxito',
        text: 'El estado de la atención ha sido actualizado correctamente',
      });

      this.$router.go(0);
    },


    canEditComentario(usuarioCreador){
      // const usuarioEnSesion = getUserNameLS(); 
      // return (usuarioCreador === usuarioEnSesion)

      return comprobarRoles([ROLES.DIGITADOR]);
    },


    async onChangeToRevisado(){
      const responseUpdateState = await atencionMedicaService.updateByToken(this.tokenAtencion, { estadoRevision: '2' });

      if (!responseUpdateState){
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'No se ha podido actualizar el estado de la atención',
        });

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Éxito',
        text: 'El estado de la atención ha sido actualizado correctamente',
      });

      this.$router.go(0);
    },



    onEditComment(comentarioToEdit){

      this.showEditComentario = true;

      if(!comentarioToEdit){
        this.comentarioToEdit = {}; 
        return;
      }

      this.comentarioToEdit = {
        ...comentarioToEdit, 
        estadoComentario:  comentarioToEdit.estadoComentario
      } 
      
    },

    onHide() {
      this.comentarioOfUser = null;
      this.comentariosOthersUsers = null;
      this.isVisible = false;
      this.comentarios = null;
    },

    setToken(){
      const urlParams = new URLSearchParams(window.location.search);
      this.onlyView = (urlParams.has('vvalidator'));

      this.tokenAtencion = this.onlyView 
        ? this.$route.query.vvalidator 
        : this.$route.query.validator;
    },

    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos');
      return permisosUsuario.indexOf(permission) !== -1;
    },

    async onGetDataComments( ){

      const estadoRevisionResponse = await atencionMedicaService.getByToken(this.tokenAtencion);

      const dataPaciente = estadoRevisionResponse?.cita.paciente.persona;
      this.paciente = `${dataPaciente.identificacion} - ${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`;
      this.estadoRevision = estadoRevisionResponse?.estadoRev;

      this.isVisible = true;

      const data = await atencionAuditoriaService.getCommentsValidacionByAtencion(this.tokenAtencion);
      console.log('data', data);
      if (!data){
        this.allComentarios = [];
        this.comentarioOfUser = { token: null, comentario: '', estadoComentario: null };
        this.isVisible = true;
        return;
      }


      this.allComentarios = data;

    },



    async onSaveComentario(comentario){
      // const response = await atencionAuditoriaService.updateComentarioValidacion(this.tokenAtencion, this.comentarioOfUser );
      const response = await atencionAuditoriaService.updateComentarioValidacion(this.tokenAtencion, comentario );

      if(!response) return;

      await this.$swal("Comentario de validación guardada.", "", "success")
      this.showEditComentario = false;

      this.$router.go(0);
    },


    estadoComentarioText(estadoComentario){
      return estadoComentario === '1' 
        ? 'Notificado' 
        : estadoComentario === '2' 
          ? 'Visto' 
          : estadoComentario === '3' 
            ? 'Concluida' 
            : 'Sin estado';
    },


    async onCambioEstado(comentario, estado){

      const result = await this.$swal({
        title: "¿Deseas cambiar el estado?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cambiar",
        cancelButtonText: "No, cancelar"
      })
      
      if(!result.isConfirmed) return;

      const comentarioChangeState = {
        ...comentario,
        estadoComentario: estado
      }

      const response = await atencionAuditoriaService.updateComentarioValidacion(this.tokenAtencion, comentarioChangeState );

      if(!response) {
        this.$swal("Error", "No se pudo cambiar el estado.", "error");
        return;
      }

      this.$swal("Comentario de validación guardada.", "", "success").then( () => this.isVisible = false );
    }
  },

  computed: {
    isDigitador() {
      return comprobarRoles( [ROLES.DIGITADOR, ROLES.JEFE_VALIDACIONES] );
    },

    isAuditor() {
      return comprobarRoles( [ROLES.AUDITOR, ROLES.JEFE_AUDITOR] );
    },

    isDoctor(){
      return comprobarRoles( ROLES.DOCTOR );
    },

  },

  watch: {

    '$route.query.validator': {
      handler(){
        this.setToken();
        this.onlyView = false;
      },
    },

    '$route.query.vvalidator': {
      handler(){
        this.setToken();
        this.onlyView = true;
      },
    },

    tokenAtencion:{
      deep:true,
      handler(newValue){
        if(!newValue) return;
        this.onGetDataComments( newValue );
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ name: 'atenciones-medicas' })
      }
    }
  }

}
</script>

<style>
  .comentario{
    border-radius: 5px; 
    border: 1px solid #0080C9; 
    padding:10px 5px; 
    margin-bottom: 15px;
  }
</style>